import { LoginPage, ForgotPasswordPage } from "./authorization";
import { UsersPage, UserPage } from "./users";
import { EventsPage, EventPage } from "./events";
import { GraphicPackingsPage, GraphicPackingPage } from './graphic-packing';
import { GraphicStandPage } from './graphic-stands';
import { GraphicWarehousePage } from './graphic-warehouse';
import { GraphicWarehouseShelvesPage } from './graphic-warehouse-shelves';
import { GraphicStoragePage, GraphicStorageDetailPage } from './graphic-storage';
import { StandPage } from "./stands";
import { StandsGlobalPage } from "./stands-global";
import { LastMinutePage } from "./last-minute";
import { TranslationAiRequestsPage, TranslationAiUsagePage } from "./settings";
import UserGroupPages from "./usergroups";
import SubcontractorPages from "./subcontractors";
import HallPages from "./halls";
import Dashboard from "./dashboard/dashboard-page";
import Page404 from "./404/404-page";


import "./pages.scss";



export const Pages = {
    Dashboard,
    Users: UsersPage,
    User: UserPage,
    Events: EventsPage,
    Event: EventPage,
    Stand: StandPage,
    StandsGlobal: StandsGlobalPage,
    UserGroup: UserGroupPages,
    Subcontractor: SubcontractorPages,
    Hall: HallPages,
    GraphicPackings: GraphicPackingsPage,
    GraphicPacking: GraphicPackingPage,
    GraphicStand: GraphicStandPage,
    GraphicWarehouse: GraphicWarehousePage,
    GraphicWarehouseShelves: GraphicWarehouseShelvesPage,
    GraphicStorage: GraphicStoragePage,
    GraphicStorageDetail: GraphicStorageDetailPage,
    LastMinute: LastMinutePage,
    TranslationAiUsage: TranslationAiUsagePage,
    TranslationAiRequests: TranslationAiRequestsPage,
    Page404,
};

export const GuestPages = {
    LoginPage,
    ForgotPasswordPage,
}
